import { type VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { OpacitySlider } from '@/components/opacity-slider';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

const FALLBACK_OPACITY = 100;

export const TextOpacity: React.FC<Props> = ({ layerId, recordId }) => {
    const editor = useEditor();
    const textOpacity = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as IVectorLayerProps;
        const { textInfo } = layerData;

        return textInfo ? textInfo.opacity : null;
    }) as number | null;

    const opacity = textOpacity != null ? ~~(textOpacity * 100) : FALLBACK_OPACITY;

    const setTextOpacity = (value: number, options = { writeHistory: true }) => {
        if (textOpacity == null) return;

        editor.getInstance<VectorLayer>('VectorLayer').setTextOpacity(layerId, value / 100, options);

        if (options.writeHistory) {
            Tracker.setTextOpacity({
                recordId,
                stageType: editor.services.editor.getCanvasType(),
                opacity: value,
                isVectorLayer: true,
            });
        }
    };

    return (
        <OpacitySlider
            value={opacity}
            onChange={(value) => setTextOpacity(value, { writeHistory: false })}
            onAfterChange={(value) => setTextOpacity(value, { writeHistory: true })}
        />
    );
};
